import React, { PureComponent } from 'react';
import _ from 'lodash';

class AttendanceSummary extends PureComponent {
   
    renderTableHeader() { 

        return (
            <thead>
                <tr className="upcase">
                    <th>{'Name'}</th>
                    <th>{'Attendance'}</th>
                    <th>{'In Time'}</th>
                    <th>{'Out Time'}</th>
                    <th>{'Total Time'}</th>
                </tr>
            </thead>
        )
    }

    renderTableBody(items) {
      if (!items) return <tr></tr>;
        return (
           
            items.map((item, index) => {
                const EmployeeName = item.EmployeeName;
                const EmployeeFirstName = _.first(item.EmployeeName.split(" "));
                const Attendance = item.Attendance;
                const inTime = item.InTime; 
                const outTime = item.OutTime;
                const TotalTime = item.TotalTime;

                return (
                    <tr key={index} className='ir-attendance-warning' style={{backgroundColor:item.ColorCode}}>
                        <td className="attd-sum-name" style={{paddingLeft: '7px'}} >{EmployeeName}</td>
                        <td className="attd-sum-fname" style={{paddingLeft: '7px'}} >{EmployeeFirstName}</td>
                        <td style={{paddingLeft: '7px'}} >{Attendance}</td>
                        <td style={{paddingLeft: '7px'}} >{inTime}</td>
                        <td style={{paddingLeft: '7px'}} >{outTime}</td>
                        <td style={{paddingLeft: '7px'}} >{TotalTime}</td>
                    </tr>
                )
            })
        );
    }

    getUserName(empFullName) {
        let name = empFullName.split(" ");
        if(name.length === 1) {
            return name[0].toLowerCase();
        } else if (name[0] === "Ram" || name[0] === "Shiv") {
            return (name[0].charAt(0) + name[1]).toLowerCase(); 
        }
        return (name[0].charAt(0) + name[name.length - 1]).toLowerCase(); 
    }

    getTooltip(inTime, outTime) {
        let tooltip = "";
        if(inTime == null) return tooltip;
        tooltip = `In Time: ${inTime}`;
        if (outTime !== null) {
            tooltip += ` Out Time: ${outTime}`
        }
        return tooltip;
    }

    renderTableBody2(items) {
        if (!items || items.length === 0) return null;

        const result = _.orderBy([...items], ['EmployeeName'], ['asc']);

        return (
            result.map((item, index) => {
                const UserName = this.getUserName(item.EmployeeName);
                const EmployeeName = item.EmployeeName;
                const EmployeeFirstName = _.first(item.EmployeeName.split(" "));
                const Attendance = item.Attendance;
                const inTime = item.InTime; 
                const outTime = item.OutTime;
                const TotalTime = item.TotalTime;

                return (
                    <li key={index} className="list-group-item" style={{ padding: '0.35rem', background: 'transparent' }}>
                        <div className={ inTime !== null ? (outTime == null ? "user-present" : "user-marked") : "user-absent" }
                            title={this.getTooltip(inTime, outTime)}>
                        <img className="img-circle img-thumbnail"
                            src={"https://static.alpaca360.com/images/profilepicture/portal/" + UserName + ".png"} alt="" 
                            style={{ width: '40px', borderRadius: '50%', padding: 2, marginRight: 5 }} />
                         {EmployeeName}
                         </div>
                    </li>
                )
            })
        );
    }

    render() {
        return (
            <>
                {/* <table className="v-table" >
                    {this.renderTableHeader()}
                    <tbody>
                        {
                            this.renderTableBody(this.props.employeeAttendanceSummary)
                        }
                    </tbody>
                </table> */}
                <ul className="list-group list-group-flush">
                    {this.renderTableBody2(this.props.employeeAttendanceSummary)}
                </ul>
            </>
        )
    }
}

export default AttendanceSummary;
